export default [
  {
    path: '/finance/main',
    name: 'finance_main',
    component: () => import('@/views/finance/index'),
    meta: { title: "科技金融服务子平台", requireLogin: false },
    redirect: '/finance/index',
    children: [
      {
        path: '/finance/index',
        name: 'finance_index',
        component: () => import('@/views/finance/components/index'),
        meta: { title: "科技金融服务子平台", requireLogin: false },
      },
      {
        path: '/finance/investor',
        name: 'finance_investor',
        component: () => import('@/views/finance/components/conts/investor'),
        meta: { title: "投资人", requireLogin: false },
        redirect: '/finance/investor/index',
        children: [
          {
            path: '/finance/investor/index',
            name: 'finance_investor_index',
            component: () => import('@/views/finance/components/conts/investorcont/index'),
            meta: { title: "投资人", requireLogin: false },
          },
          {
            path: '/finance/investor/page',
            name: 'finance_investor_page',
            component: () => import('@/views/finance/components/conts/investorcont/page'),
            meta: { title: "投资人详情", requireLogin: false },
          }
        ]
      },
      {
        path: '/finance/investorCenter',
        name: 'finance_investorCenter',
        component: () => import('@/views/finance/components/conts/InvestorCenter'),
        meta: { title: "金融顾问", requireLogin: false },
        redirect: '/finance/investorCenter/index',
        children: [
          {
            path: '/finance/investorCenter/index',
            name: 'finance_investorCenter_index',
            component: () => import('@/views/finance/components/conts/investorCentercont/index'),
            meta: { title: "金融顾问", requireLogin: false },
          },
          {
            path: '/finance/investorCenter/page',
            name: 'finance_investorCenter_page',
            component: () => import('@/views/finance/components/conts/investorCentercont/page'),
            meta: { title: "金融顾问详情", requireLogin: false },
          }
        ]
      },
      
      {
        path: '/finance/need',
        name: 'finance_need',
        component: () => import('@/views/finance/components/conts/need'),
        meta: { title: "融资需求", requireLogin: false },
        redirect: '/finance/need/index',
        children: [
          {
            path: '/finance/need/index',
            name: 'finance_need_index',
            component: () => import('@/views/finance/components/conts/needcont/index'),
            meta: { title: "融资需求", requireLogin: false },
          },
          {
            path: '/finance/need/page',
            name: 'finance_need_page',
            component: () => import('@/views/finance/components/conts/needcont/page'),
            meta: { title: "融资需求详情", requireLogin: false },
          }
        ]
      },
      {
        path: '/finance/invertorInstitution',
        name: 'finance_invertorInstitution',
        component: () => import('@/views/finance/components/conts/invertorInstitution'),
        meta: { title: "金融机构", requireLogin: false },
        redirect: '/finance/institution/index',
        children: [
          {
            path: '/finance/institution/index',
            name: 'finance_institution_index',
            component: () => import('@/views/finance/components/conts/institutioncont/index'),
            meta: { title: "金融机构", requireLogin: false },
          },
          {
            path: '/finance/institution/page',
            name: 'finance_institution_page',
            component: () => import('@/views/finance/components/conts/institutioncont/page'),
            meta: { title: "金融机构详情", requireLogin: false },
          }
        ]
      },
      {
        path: '/finance/project',
        name: 'finance_project',
        component: () => import('@/views/finance/components/conts/project'),
        meta: { title: "创业项目", requireLogin: false },
        redirect: '/finance/project/index',
        children: [
          {
            path: '/finance/project/index',
            name: 'finance_project_index',
            component: () => import('@/views/finance/components/conts/projectcont/index'),
            meta: { title: "创业项目", requireLogin: false },
          },
          {
            path: '/finance/project/page',
            name: 'finance_project_page',
            component: () => import('@/views/finance/components/conts/projectcont/page'),
            meta: { title: "创业项目详情", requireLogin: false },
          }
        ]
      },
      {
        path: '/finance/financialProduct',
        name: 'finance_financialProduct',
        component: () => import('@/views/finance/components/conts/financialProduct'),
        meta: { title: "金融产品", requireLogin: false },
        redirect: '/finance/product/index',
        children: [
          {
            path: '/finance/product/index',
            name: 'finance_product_index',
            component: () => import('@/views/finance/components/conts/productcont/index'),
            meta: { title: "金融产品", requireLogin: false },
          },
          {
            path: '/finance/product/page',
            name: 'finance_product_page',
            component: () => import('@/views/finance/components/conts/productcont/page'),
            meta: { title: "金融产品详情", requireLogin: false },
          }
        ]
      },
      {
        path: '/finance/video',
        name: 'finance_video',
        component: () => import('@/views/finance/components/conts/video'),
        meta: { title: "金融课堂", requireLogin: false }
      },
      {
        path: '/finance/video/Detail',
        name: 'finance_video_Detail',
        component: () => import('@/views/finance/components/conts/consultationcont/videoDetail'),
        meta: { title: "金融课堂", requireLogin: false },
      },
      {
        path: '/finance/activery',
        name: 'finance_activery',
        component: () => import('@/views/finance/components/conts/consultation1'),
        meta: { title: "项目路演", requireLogin: false }
      },
      {
        path: '/finance/activery/Detail',
        name: 'finance_activery_Detail',
        component: () => import('@/views/finance/components/conts/consultationcont/activeryDetail'),
        meta: { title: "项目路演", requireLogin: false },
      },
      {
        path: '/finance/law',
        name: 'finance_law',
        component: () => import('@/views/finance/components/conts/consultation'),
        meta: { title: "法律法规", requireLogin: false },
      },
      {
        path: '/finance/law/page',
        name: 'finance_law_page',
        component: () => import('@/views/finance/components/conts/consultationcont/noticeDetail'),
        meta: { title: "法律法规", requireLogin: false },
      },
      {
        path: '/finance/notice',
        name: 'finance_notice',
        component: () => import('@/views/finance/components/conts/consultationGg'),
        meta: { title: "通知公告", requireLogin: false },
      },
      {
        path: '/finance/notice/page',
        name: 'finance_notice_page',
        component: () => import('@/views/finance/components/conts/consultationcont/noticeDetailGg'),
        meta: { title: "通知公告", requireLogin: false },
      },
      {
        path: '/finance/ScienceTechnologyLoan',
        name: 'finance_ScienceTechnologyLoan',
        component: () => import('@/views/finance/components/conts/ScienceTechnologyLoan'),
        meta: { title: "科创贷", requireLogin: false },
      }
      

    ]
  },
  // {
  //   path: '/finance/recruitment',
  //   name: 'finance_recruitment',
  //   component: () => import('@/views/finance/components/recruitment'),
  //   meta: { title: "子栏目", requireLogin: false },
  //   children: [
  //     {
  //       path: '/finance/investor',
  //       name: 'finance_investor',
  //       component: () => import('@/views/finance/components/conts/investor'),
  //       meta: { title: "投资人", requireLogin: false }
  //     },
  //     {
  //       path: '/finance/invertorInstitution',
  //       name: 'finance_invertorInstitution',
  //       component: () => import('@/views/finance/components/conts/invertorInstitution'),
  //       meta: { title: "投资机构", requireLogin: false }
  //     },
  //     {
  //       path: '/finance/financialProduct',
  //       name: 'finance_financialProduct',
  //       component: () => import('@/views/finance/components/conts/financialProduct'),
  //       meta: { title: "金融产品", requireLogin: false }
  //     },
  //   ]
  // }
]
